import { httpCreate } from './http';

const http = httpCreate('/srv/guess-activity');

export const guessActivity = {
	// 获取活动列表
	guessActivityList(activityId, pageNum, pageSize) {
		return http.get(`/list/${activityId}?pageNum=${pageNum}&pageSize=${pageSize}`);
	},
	// 获取奖品列表
	guessPrizeList(id) {
		return http.get(`/prizeList/${id}`);
	},
	// 获取问答详情
	getGuessDetail(id) {
		return http.get(`/${id}`);
	},
	// 创建答题
	createGuessActivity(activityId, smsCode, params) {
		return http.post(`/${activityId}?smsCode=${smsCode}`, params);
	},
	// 修改问答信息
	fixGuessActivity(id, smsCode, params) {
		return http.put(`/${id}?smsCode=${smsCode}`, params);
	},
	// 开启竞猜活动
	startGuessActivity(activityId, id) {
		return http.post(`/start/${activityId}/${id}`);
	},
	// 手动切题
	cutQuestion(activityId, guessActivityId) {
		return http.post(`/next/${activityId}/${guessActivityId}`);
	},
	// 删除问答
	deleteGuessActivity(guessActivityId) {
		return http.delete(`/${guessActivityId}`);
	},
	// 核销
	guessWriteOff(id, formData) {
		return http.put(`/user/verdict/${id}`, formData);
	},
	// 参与列表
	partakeList(activityId, guessActivityId, params) {
		return http.get(
			`/user/list/${activityId}?guessActivityId=${guessActivityId}&pageSize=${params.pageSize}&pageNum=${params.pageNum}&result=${params.result}&verdictStatus=${params.verdictStatus}&winNo=${params.winNo}`
		);
	},
	// 获取直播间所有活动（用于下拉列表）
	getActivityAll(activityId) {
		return http.get(`/all/${activityId}`);
	},
};
